var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-160.07 -284.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 656.96 439.54)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1878-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.3821)",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1881.2-560.86h4.5801v1.7318q0 1.8457 0.8203 2.7116 0.8203 0.86589 2.6888 0.86589h9.4108q1.8685 0 2.6888-0.86589 0.8203-0.86588 0.8203-2.7116v-2.5293q0-1.8685-0.8203-2.7116t-2.6888-0.8431h-9.6614v-4.5573h9.5247q1.709-0.0684 2.4382-0.91146 0.7519-0.86588 0.7519-2.6432v-2.1419q0-1.8685-0.8431-2.7344-0.8203-0.86589-2.666-0.86589h-8.4993q-1.8458 0-2.6661 0.86589-0.8203 0.86588-0.8203 2.7344v1.7318h-4.5801v-1.9596q0-7.9525 7.9297-7.9525h8.7728q4.0332 0 5.9701 1.9596 1.9596 1.9596 1.9596 5.9928v0.59245q0 2.7572-0.9798 4.5573-0.957 1.7773-2.8027 2.6432 2.0735 0.61523 3.1673 2.4609 1.0937 1.8457 1.0937 4.8991v1.6406q0 7.9297-7.9297 7.9297h-9.707q-7.9525 0-7.9525-7.9297z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.0f7c02dd476f1d807a283e59b91c800b.svg";
export { ForwardRef as ReactComponent };